// depends-on: Bootstrap mobile
// depends-on: efw.local
/* global require */
(function ($) {
    const _ = require('lodash');

    // Eightfold Way plugin for collapsing inline tools
    $.fn.efw$toolCollapse = function (/* options */) {
        return this.each(function () {
            let $this = $(this),
                $content = $this.find('.styleCalcExpand'),
                $toggleWrapper = $this.find('.button-wrapper'),
                id = $content.attr('id');

            if (!id) {
                console.warn('efw.toolCollapse: content id attribute missing!');
            }

            let $control = $('<button class="calc-toggle-button grow" href="#' + id + '" data-toggle="collapse" aria-expanded="false" aria-controls="' + id + '"><span class="text">' + 'toolcollapse.showmore'._local() + '</span></button>');
            $toggleWrapper.append($control);

            let $showLess = $('<button class="calc-toggle-button growUp" href="#' + id + '" data-toggle="collapse" aria-expanded="true" aria-controls="' + id + '"> <span class="text">' + 'toolcollapse.showless'._local() + '</span></button>');
            $toggleWrapper.append($showLess);

            // prevent buttons from submitting forms
            $toggleWrapper.find('button').on('click', function (e) { e.preventDefault(); });

            $content.addClass('collapse');
            $content.on('show.bs.collapse', function () {
                    $(this).closest('.styleCalcInsertTryIt').addClass('shown');
                })
                .on('hide.bs.collapse', function () {
                    $(this).closest('.styleCalcInsertTryIt').removeClass('shown');
                });
            //$this.trackEvents({
            //    category: 'Clicks', action: 'ShowMore', label: function (o) {
            //        var $h2 = o.parent('div.toolCollapse').prevUntil('h2').first().prev('h2');
            //        return ($h2.length > 0 ? $h2.text() : '" + strShowMore + @"');
            //    }
            //});
        });
    };

    // activate globally.
    $(document).ready(function () {
        _.defer(function () {
            $('.styleCalcInsertTryIt').efw$toolCollapse();
        });
    });
})(jQuery);
